<!-- 侧栏 - 美化版本 -->
<template>
  <div class="sidebar">
    <div class="sidebar-menu">
      <!-- 主菜单 -->
      <div v-for="(item, index) in gtab" :key="index" class="menu-category" :class="{ active: index === gcurr }">
        <div class="menu-header" @click="toggleMenu('tab-' + index)">
          <div class="menu-icon">
            <i class="el-icon-truck"></i>
          </div>
          <div class="menu-title">{{ item }}</div>
          <div class="menu-arrow" v-if="showTabSubmenu(index)" :class="{ 'arrow-down': openMenus.includes('tab-' + index) }" @click.stop="toggleMenu('tab-' + index)">
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
        
        <div class="submenu" v-show="showTabSubmenu(index)" v-if="openMenus.includes('tab-' + index)">
          <div 
            class="status-item"
            v-for="(navItem, navIndex) in getTabNav(index)"
            :key="navIndex" 
            @click.stop="set_status(navItem)"
            :class="{ 'active': isStatusActive(index, navItem) }"
          >
            {{ navItem.name }}
          </div>
        </div>
       
      </div>
      
      <!-- 个人菜单 -->
      <div class="menu-category" :class="{ active: isActive('personal') }">
        <div class="menu-header" @click="toggleMenu('personal')">
          <div class="menu-icon">
            <i class="el-icon-user"></i>
          </div>
          <div class="menu-title">{{ $lang(42432) }}</div>
          <div class="menu-arrow" :class="{ 'arrow-down': openMenus.includes('personal') }">
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
        
        <div class="submenu" v-show="openMenus.includes('personal')">
          <div class="menu-item" :class="{ active: def === '/personal' }" @click="go_uu('/personal')">
            <i class="el-icon-user-solid"></i>
            <span>{{ $lang(50044) }}</span>
          </div>
          
          <div class="menu-item" :class="{ active: def === '/coupon' }" @click="go_uu('/coupon')">
            <i class="el-icon-s-ticket"></i>
            <span>{{ $lang(50045) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sidebar",
  props: {
    def: {
      type: String,
      required: true,
      default: '/bus_list',
    }
  },
  data() {
    return {
      dd: '/',
      tt : -1,
      openMenus: [],
      gtab: ["热门专线订单", "景点订单"],
      gcurr: 0,
      s: -1,
      busNav: [
        { name: this.$lang(42434), v: -1 },
        { name: this.$lang(42435), v: 0 },
        { name: this.$lang(42437), v: 1 },
        { name: this.$lang(42436), v: 2 },
        { name: this.$lang(42439), v: 3 },
        { name: this.$lang(42438), v: 4 },
        { name: this.$lang(49603), v: 5 }
      ],
      scenicNav: [
        { name: '全部', v: 'all' },
        { name: '待付款', v: 'pending' },
        { name: '出票中', v: 'paid' },
        { name: '已发货', v: 'send' },
        { name: '已取消', v: 'cancelled' },
        { name: '已退款', v: 'refunded' }
      ]
    }
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        if (newQuery.s !== undefined) {
          this.s = newQuery.s;
        }
        if (newQuery.t !== undefined) {
          const currentTab = parseInt(newQuery.t, 10);
          this.tt = currentTab === 2 ? 1 : currentTab;
          this.gcurr = this.tt;
        }
        
      
      },
      deep: true
    }
  },
  mounted() {
    // 初始化时根据当前路由打开对应菜单
    if (this.def.includes('bus_list')) {
   
      // 设置初始状态
      this.s = -1
      if (this.$route.query.s !==undefined) {
        const currentStatus = this.$route.query.s;
        this.s = currentStatus === 'all' ? 'all' : parseInt(currentStatus, 10);
      }
      this.tt = -1
      if (this.$route.query.t !==undefined) {
        const currentTab = parseInt(this.$route.query.t, 10);
        this.tt = currentTab === 2 ? 1 : currentTab;
        this.gcurr = this.tt;
        this.openMenus.push('tab-' + this.tt );
      }
    } else if (this.def.includes('/personal') || this.def.includes('/coupon')) {
      this.openMenus.push('personal');
    }
    console.log(this.tt, 'tt');  
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    go_uu(path) {
      this.jump(path, {}, true);
    },
    showTabSubmenu(index) {
      return index === 0 || index === 1;
    },
    getTabNav(index) {
      if (index === 1) return this.scenicNav;
      return this.busNav;
    },
    isStatusActive(index, navItem) {
      if (index !== this.tt) return false;
      if (index === 1) {
        if ((this.s === -1 || this.s === undefined) && navItem.v === 'all') return true;
        return String(this.s) === String(navItem.v);
      }
      return String(this.s) === String(navItem.v);
    },
    toggleMenu(menu) {
      // 清空所有已打开的菜单
      this.openMenus = [];
      
      if (menu.startsWith('tab-')) {
        const tabIndex = parseInt(menu.split('-')[1]);
        this.gcurr = tabIndex;
        this.$emit('change-tab', tabIndex);
        
        // 如果是没有子菜单的选项，直接跳转
        if (tabIndex > 1) {
          this.jump('/bus_list', { t: tabIndex, s: this.s, key: Date.now() }, true);
          return;
        }
        if (tabIndex === 1) {
          this.s = 'all';
          this.openMenus.push(menu);
          this.jump('/bus_list', { t: tabIndex, s: 'all', key: Date.now() }, true);
          return;
        }
        
        // 有子菜单的选项，展开菜单
        this.openMenus.push(menu);
      } else if (menu === 'personal') {
        // 处理个人菜单的展开
        this.openMenus.push(menu);
      }
    },
    isActive(menu) {
      if (menu === 'bus' && this.def.includes('/bus_list')) {
        return true;
      } else if (menu === 'personal' && (this.def.includes('/personal') || this.def.includes('/coupon'))) {
        return true;
      }
      return false;
    },

    onChange(index) {
      this.gcurr = index;
      this.$emit('change-tab', index);
    },
    set_status(itm) {
      this.s = itm.v;
      this.$emit('change-status', itm.v);
      // 跳转到bus_list并传递参数
      this.jump('/bus_list', { t: this.gcurr, s: itm.v, key: Date.now() }, true);
    }
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
  max-height: 300px;
  overflow: hidden;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  max-height: 0;
  overflow: hidden;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
  max-height: 0;
}

.sidebar {
  width: 248px;
  flex: 0 0 248px;
  margin-top: 0;
  min-height: 50vh;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 15px;
  transition: all 0.3s ease;
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-category {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.menu-category.active {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.menu-header {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
  background: linear-gradient(to right, #f8f9fa, #ffffff);
  transition: all 0.3s ease;
  border-radius: 8px;
}

.menu-header:hover {
  background: linear-gradient(to right, #f0f2f5, #f8f9fa);
}

.menu-icon {
  margin-right: 10px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409EFF;
  font-size: 18px;
}

.menu-title {
  flex: 1;
  font-weight: 500;
  color: #303133;
}

.menu-arrow {
  transition: transform 0.3s ease;
}

.arrow-down {
  transform: rotate(180deg);
}

.submenu {
  padding: 5px 0;
  background-color: #fafbfc;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px 15px 10px 35px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #606266;
  font-size: 14px;
}

.menu-item:hover {
  background-color: rgba(64, 158, 255, 0.08);
  color: #409EFF;
}

.menu-item.active {
  background-color: rgba(64, 158, 255, 0.1);
  color: #409EFF;
  font-weight: 500;
}

.menu-item i {
  margin-right: 8px;
  font-size: 14px;
  width: 16px;
  text-align: center;
}

.nav-category {
  margin-bottom: 10px;
}

.nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.3s;
  color: #606266;
  position: relative;
  
  &:hover {
    background: #e6f7ff;
    color: #1890ff;
  }
  
  &.active {
    background: #e6f7ff;
    color: #1890ff;
    border-right: 3px solid #1890ff;
  }
}

.toggle-btn {
  position: absolute;
  right: 15px;
  font-size: 12px;
  color: #1890ff;
  cursor: pointer;
  padding: 2px 5px;
  border-radius: 3px;
  background-color: #e6f7ff;
  
  &:hover {
    background-color: #1890ff;
    color: white;
  }
}

.status-container {
  margin-top: 5px;
  padding: 0 20px 0 30px;
  border-left: 1px solid #e6e6e6;
  margin-left: 10px;
  overflow: hidden;
}

.status-item {
  padding: 8px 15px;
  margin-bottom: 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  color: #606266;
  font-size: 14px;
  position: relative;
  
  &:hover {
    background: #f0f0f0;
  }
  
  &.active {
    background: #1890ff;
    color: white;
    &::before {
      content: '';
      position: absolute;
      left: -15px;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      background: #1890ff;
      border-radius: 50%;
    }
  }
}

@media (max-width: 1366px) {
  .sidebar {
    width: 224px;
    flex-basis: 224px;
    padding: 12px;
  }

  .menu-header {
    padding: 11px 12px;
  }

  .menu-title,
  .status-item,
  .menu-item {
    font-size: 13px;
  }
}

@media (max-width: 1180px) {
  .sidebar {
    width: 208px;
    flex-basis: 208px;
    padding: 10px;
  }

  .menu-icon {
    margin-right: 8px;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 90%;
    flex: none;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/sidebar.vue